module.exports = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div id=\"preloader-container\">\n	<p>Preloading images</p>\n	<div class=\"meter\">\n        <p class=\"progress\">Progress <span>0</span></p>\n        <div style=\"width: 0\">\n            <p class=\"progress\">Progress <span>0</span></p>\n        </div>\n    </div>\n\n</div>";
  });